// extracted by mini-css-extract-plugin
module.exports = {"root":"UserNav_root__d8X1V","tab":"UserNav_tab__2H_li"};